import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import Thunk, { ThunkConfig } from './';
import notification from 'src/store/ui/notification';
import { Data } from 'src/interfaces/general';

const fileUpload = new Thunk();

export type GenerateURL = {
  file_name: string;
  module: string;
};

export type UploadPayload = {
  url: string;
  file: File;
  ext: string;
  onSuccess?: () => void;
  onError?: () => void;
};

export const generateURL = fileUpload.create<
  Data<Model.UPLOAD_URL>,
  GenerateURL
>('files/upload_urls');

export const uploadS3 = createAsyncThunk<any, UploadPayload>(
  'upload_s3',
  async (args, { dispatch }) => {
    const { url, file, ext, onSuccess, onError } = args;
    const content_type = ext.split('.')[1];

    const data = new FormData();
    data.append('file', file, file.name);

    try {
      await axios.put(url, file, {
        headers: {
          'Content-Type': `image/${content_type}`,
          'X-Amz-Acl': 'public-read',
        },
      });

      onSuccess?.();
    } catch (err) {
      onError?.();
      dispatch(
        notification.on({ type: 'error', message: 'An error occurred' }),
      );
    }
  },
);

export type ImageUpload = {
  images: File[];
};

export const uploadImage = createAsyncThunk<
  Data<Model.UPLOAD_URL[]>,
  ImageUpload,
  ThunkConfig
>('upload_image', async (args, { dispatch }) => {
  const data = new FormData();

  for (let file of args.images) {
    data.append('images[]', file);
  }

  try {
    const res = await fileUpload.post('files/upload_images', data);

    return res.data;
  } catch (err) {
    dispatch(notification.on({ type: 'error', message: 'An error occurred' }));
  }
});
